import { render } from "./RegionAggregatedBaseInfo.vue?vue&type=template&id=44235b7b&ts=true"
import script from "./RegionAggregatedBaseInfo.vue?vue&type=script&lang=ts"
export * from "./RegionAggregatedBaseInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__